import { ActionContext } from 'vuex';

import api from '@/api';
import { ApiEventsList, PropertiesList } from '@/api/types/events';

interface EventsState {
    list: ApiEventsList;
    listRequestPending: boolean;
}

const events = {
    namespaced: true,
    state: {
        list: {},
        listRequestPending: false,
    },
    getters: {
        items(state: EventsState): Array<ApiEventsList> {
            if (typeof state.list.List === 'undefined' || !state.list.List || state.list.List.length === 0) {
                return [];
            }

            const items = JSON.parse(JSON.stringify(state.list.List));
            return items;
        },
    },
    mutations: {
        startListRequest(state: EventsState): void {
            state.listRequestPending = true;
        },
        endListRequest(state: EventsState): void {
            state.listRequestPending = false;
        },
        updateList(state: EventsState, list: ApiEventsList): void {
            state.list = list;
        },
        clearList(state: EventsState): void {
            state.list = {};
        },
    },
    actions: {
        clearList(context: ActionContext<EventsState, null>): void {
            context.commit('clearList');
        },
        async list(context: ActionContext<EventsState, null>, data: PropertiesList): Promise<void> {
            context.commit('startListRequest');
            try {
                const token = window.localStorage.getItem('authcredentials');
                const response = await api.events.list(data, token || '');
                context.commit('updateList', response.data);
            } catch (err) {
                // console.log(err);
            } finally {
                context.commit('endListRequest');
            }
        },
    },
};

export default events;
